/**
 * Available or unavailable and 5:45 shift port codes and their bit position expressed in base10 which is useful when constructing the
 * argument that needs to be sent to the WebApi to submit a make me available request
 * for instance:
 * available: 1,
 * unavailable: 0,
 * available for 5:45 shift Vancouver: 2
 * available for 5:45 shift SQUAMISH: 4
 * available for 5:45 VANCOUVER and SQUAMISH: 1 + 2 + 4 = 7
 * available for Night shift: 2
 * available for Graveyard shift: 4
 * available for Night and Graveyard shifts: 1 + 2 + 4 = 7
 */
export enum AvailableCode {
  NOT_AVAILABLE = 0,
  AVAILABLE = 1,
  /**
   *  17:45 Dispatch Vancouver option 
   *  Night Dispatch Night Dispatch option
   */
  OPTION_1 = 3,
  /**
   *  17:45 Dispatch SQUAMISH option 
   *  Night Dispatch GRAVEYARD Dispatch option
   */
  OPTION_2 = 5,
}

export const SUCCESS_MSG = 'Action was successful.';